import React, { useState, useEffect } from "react";

import { Badge, Col, Descriptions, Row, Select, Spin, Typography } from "antd";
import { htmlReplace } from "../../../util/ReactHelper";
import moment from "moment";
import { DateFormats } from "../../../core/common/Constants";
import { PaperClipOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Text, Paragraph } = Typography;

const START_SEARCH_TRESHOLD = 3;

interface TData {
  value: string;
  text: string;
}

interface TSearchInput {
  fetching?: boolean;
  data: any;
  placeholder: string;
  style?: any;
  searchAndUpdateData(value: string): void;
  onChange(value: any): void;
  translate: any;
  mode?: any;
}

const SearchInput: React.FunctionComponent<TSearchInput> = ({
  fetching,
  data,
  placeholder,
  style,
  searchAndUpdateData,
  onChange,
  translate,
  mode
}) => {
  const [value, setValue] = useState(undefined);
  const [list, setList] = useState(data);

  useEffect(() => {
    setList(data);
  }, [data]);

  const handleSearch = (value) => {
    if (value?.length > START_SEARCH_TRESHOLD) {
      searchAndUpdateData(value);
    } else {
      setList([]);
    }
  };

  const handleChange = (value) => {
    setValue(value);
    onChange(value);
  };
  const elements = list?.map((item) => (
    <Option
      key={item.collection_item_id}
      value={item.collection_item_id}
      title={item.summary}
      label={item.summary}
    >
      <Row>
        <Col xs={24} sm={24}>
          <Paragraph ellipsis={{ rows: 3 }}>
            {htmlReplace(item.summary, (tag, props) => {
              if (tag === "em") {
                return <Text mark />;
              }
            })}
          </Paragraph>
        </Col>
        <Col xs={24} sm={24} className={"card-list-item-decriptions"}>
          <Descriptions
            size={"small"}
            column={{ xs: 1, sm: 1, md: 1, lg: 4, xl: 4, xxl: 4 }}
          >
            <Descriptions.Item
              span={1}
              label={
                <strong>
                  {translate("editors.case_law_documents.primary_court_case")}
                </strong>
              }
            >
              {item.primary_court_case_number_s}
            </Descriptions.Item>
            <Descriptions.Item
              span={1}
              label={
                <strong>{translate("editors.case_law_documents.date")}</strong>
              }
            >
              {moment(item.date_dt)?.format(DateFormats.DATE)}
            </Descriptions.Item>
            {item.attr_index_name?.length > 0 && (
              <Descriptions.Item
                span={3}
                label={
                  <strong>
                    {translate(
                      "search.case_law_documents.index_data",
                      undefined,
                      item.attr_index_name?.length
                    )}
                  </strong>
                }
              >
                <Paragraph ellipsis={{ rows: 3 }}>
                  {item.attr_index_name?.map((name, index) => (
                    <span key={`attr-index-name-${index}`}>
                      {index !== item.attr_index_name.length - 1
                        ? `${name}, `
                        : `${name}`}
                    </span>
                  ))}
                </Paragraph>
              </Descriptions.Item>
            )}
            {item.decision_date_dt && (
              <Descriptions.Item
                span={1}
                label={
                  <strong>
                    {translate("editors.case_law_documents.decision_date")}
                  </strong>
                }
              >
                {moment(item.decision_date_dt)?.format(DateFormats.DATE)}
              </Descriptions.Item>
            )}
          </Descriptions>
        </Col>
      </Row>
    </Option>
  ));

  return (
    <Select
      mode={mode}
      showSearch
      value={value}
      placeholder={placeholder}
      style={style}
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      notFoundContent={fetching ? <Spin size="small" /> : null}
    >
      {elements}
    </Select>
  );
};

export default SearchInput;
